import { render, staticRenderFns } from "./TableDestinations.vue?vue&type=template&id=91d55b46&"
import script from "./TableDestinations.vue?vue&type=script&lang=js&"
export * from "./TableDestinations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91d55b46')) {
      api.createRecord('91d55b46', component.options)
    } else {
      api.reload('91d55b46', component.options)
    }
    module.hot.accept("./TableDestinations.vue?vue&type=template&id=91d55b46&", function () {
      api.rerender('91d55b46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/72235100-2/components/TableDestinations.vue"
export default component.exports